import ElementConstants from '../../elements';

const PublicSiteExtraElements = {
	HORIZONTAL_DIVIDER: {
		type: ElementConstants.EXTRAS.HORIZONTAL_DIVIDER,
		tag: 'div'
	},
	TEXT_BOX: {
		type: ElementConstants.EXTRAS.TEXT_BOX,
		tag: 'div',
		content: 'Text'
	}
}

export default PublicSiteExtraElements;



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/shared/constants/elements/public-site/extras.js